// The Rails app publishes the account currency in a <meta> tag; the marketing
// site is euro-only, so this shim keeps the calculator controllers unchanged.
export function currencySymbol() {
  return document.querySelector('meta[name="currency-symbol"]')?.content || "€"
}
